import _objectSpread from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
import linkInput from '@/gikam/js/components/template/fields/link.vue';
import { mapState } from 'vuex';
export default {
  props: {
    options: Object,
    propValue: String,
    validateArg: Object,
    dataId: [Number, String]
  },
  components: {
    linkInput: linkInput
  },
  computed: _objectSpread({}, mapState(['form'])),
  mounted: function mounted() {
    this.form.editorManager[this.options.field] = this.$refs.editor;
  },
  methods: {
    clickHandle: function clickHandle() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['click'].concat(args));
    }
  }
};